type StageSubCategory = {
    // problem: string;
    subcategory: string[]
}

export const stageSubCategory: Map<string, StageSubCategory> = new Map()

stageSubCategory.set('MUROS DE ARRIMO (PAREDES DE CONTENÇÃO DE TERRA)', {
    subcategory: ['IMPERMEABILIZAÇÃO FINAL DO MUROS DE ARRIMO', 
        'COLA PARA CHAPISCO',
        'REGULARIZAÇÃO DAS PAREDES'
    ]
})
stageSubCategory.set('VIGA BALDRAME', {
    subcategory: ['EXECUÇÃO DE CONCRETO',
        'REGULARIZAÇÃO DA VIGA BALDRAME',
        'IMPERMEABILIZAÇÃO FINAL DE VIGAS BALDRAME',
    ]
})
stageSubCategory.set('EXECUÇÃO DE CONCRETO DE PILARES, VIGAS E LAJES', {
    subcategory: []
})
stageSubCategory.set('RESERVATÓRIOS DE CONCRETO VAZANDO', {
    subcategory: ['ASSENTAMENTO DE ALVENARIA',
        'COLAS PARA CHAPISCO',
        'IMPERMEABILIZAÇÃO E LIGA PARA REBOCO'
    ]
})
stageSubCategory.set('CONTRAPISOS E REGULARIZAÇÕES', {
    subcategory: ['COLA PARA CONTRAPISOS E REGULARIZAÇÕES',
        'IMPERMEABILIZANTES PARA CONTRAPISOS E REGULARIZAÇÕES'
    ]
})
stageSubCategory.set('PROTEÇÃO PARA PINTURA INTERNA', {
    subcategory: ['IMPERMEABILIZAÇÃO CONTRA UMIDADE DE RODAPÉ']
})
stageSubCategory.set('PROTEÇÃO PARA PINTURA EXTERNA', {
    subcategory: ['IMPERMEABILIZAÇÃO CONTRA BATIDAS DE CHUVA']
})
stageSubCategory.set('PROTEÇÃO PARA BANHEIROS, COZINHAS E ÁREAS FRIAS', {
    subcategory: ['IMPERMEABILIZAÇÃO DE BANHEIROS COZINAS E ÁREAS FRIAS SOBRE O REBOCO',
        'TRATAMENTO CONTRA INFILTRAÇÕES EM LAJES EXPOSTAS, TELHAS E CALHAS'
    ]
})
stageSubCategory.set('IMPERMEABILIZAÇÃO DE LAJES SEM PROTEÇÃO EXPOSTAS AO SOL', {
    subcategory: ['REDUÇÃO DO CALOR E IMPERMEABILIZAÇÃO DE TELHAS METÁLICAS E FIBROCIMENTOS']
})
stageSubCategory.set('IMPERMEABILIZAÇÃO DE LAJES DE COBERTURA COM ACABAMENTO', {
    subcategory: ['']
})
stageSubCategory.set('PISCINAS', {
    subcategory: ['EXECUÇÃO DE CONCRETO OU ALVENARIA ESTRUTURAL',
        'COLA PARA CHAPISCO',
        'IMPERMEABILIZAÇÃO DA MASSA DE REGULARIZAÇÃO',
        'IMPERMEABILIZAÇÃO PISOS E PAREDE DA PISCINA'
    ]
})
stageSubCategory.set('RESERVATÓRIOS DE ÁGUA POTÁVEL', {
    subcategory: ['EXECUÇÃO DE CONCRETO OU ALVENARIA ESTRUTURAL',
        'COLA PARA CHAPISCO',
        'IMPERMEABILIZAÇÃO DA MASSA DE REGULARIZAÇÃO',
        'IMPERMEABILIZAÇÃO PISOS E PAREDE DO RESERVATÓRIO'
    ]
})
stageSubCategory.set('ALVENARIA, CHAPISCO E REBOCO', {
    subcategory: ['IMPERMEABILIZAÇÃO E LIGA PARA REBOCO', 
        'IMPERMEABILIZAÇÃO DO REBOCO',
    ]
})
stageSubCategory.set('TRATAMENTO CONTRA UMIDADE DE PÉ DE PAREDE OU MOFO DE RODAPÉ', {
    subcategory: ['IMPERMEABILIZAÇÃO CONTRA UMIDADE DE RODAPÉ',
        'CIMENTO POLIMÉRICO SOBRE OS TIJOLOS',
        'IMPERMEABILIZAÇÃO DO REBOCO',
        'MASSA CORRIDA IMPERMEÁVEL'
    ]
})
stageSubCategory.set('LAJES DE COBERTURA, PLAYGROUNDS, GARAGENS COM CORROSÃO E INFILTRAÇÕES', {
    subcategory: []
})
stageSubCategory.set('COLAGEM FLEXÍVEL DE RUFOS, CALHAS, ESPELHOS, CUBAS, PIAS, VASOS SANITÁRIOS', {
    subcategory: []
})
stageSubCategory.set('COLAGENS ESTRUTURAIS DE CONCRETO COM CONCRETO, FERRO E FIXADORES EM CONCRETO', {
    subcategory: []
})
stageSubCategory.set('INFILTRAÇÕES EM PAREDES E MUROS EXTERNOS', {
    subcategory: ['PINTURA EMBORRACHADA',
        'TRATAMENTO DE TRINCAS'
    ]
})


